import { render, staticRenderFns } from "./DonatePaybox.vue?vue&type=template&id=298ff476&scoped=true&"
import script from "./DonatePaybox.vue?vue&type=script&lang=js&"
export * from "./DonatePaybox.vue?vue&type=script&lang=js&"
import style0 from "./DonatePaybox.vue?vue&type=style&index=0&id=298ff476&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298ff476",
  null
  
)

export default component.exports